import { useParams } from "react-router-dom";
import PersonalDrive from "../../PersonalDrive";
import { fetchSingleTeamDrive, fetchSingleTeamSingleDrive } from "../../../../../api/businessAndEnterprise/driveApi";

const SingleTeamDrive = () => {
    const { id } = useParams();

    return (
        <>
            <PersonalDrive
                id={id}
                fetchApiFunc={fetchSingleTeamDrive}
                fetchSingleDriveApiFunc={fetchSingleTeamSingleDrive}
                isAddEdit={false}
            />
        </>
    );
};

export default SingleTeamDrive;